import React, { FC } from 'react';

import { InformationStep, InformationStepProps } from 'app/components/information-step';

import { StyledTitle } from './success-information.styled';

interface OwnProps {
    title: string;
    description?: React.ReactNode;
}

export type SuccessInformationProps = OwnProps & InformationStepProps;

export const SuccessInformation: FC<SuccessInformationProps> = (props) => {
    const { title, description, ...rest } = props;

    return (
        <InformationStep {...rest}>
            <StyledTitle component="p" variant="paragraph1">
                {title}
            </StyledTitle>
            {description}
        </InformationStep>
    );
};
